
import { Component, Prop } from 'vue-property-decorator';
import BasicControl from '@/ui/components/devices/devices/BasicControl';

/**
 * Component that represent OutputField Basic Control
 */
@Component
export default class OutputFieldBase extends BasicControl {
  @Prop() variableData!: any;
  @Prop() modificationFn?: Function;
  @Prop() instance!: string;
  @Prop() min!: number;
  @Prop() max!: number;
  @Prop({ default: false }) isDecimal?: boolean;
  @Prop({ default: false }) disableMinMaxFilter?: boolean;

  get actualValue(): any {
    return this.measurements.get(this.mappingsClean.actualValue);
  }

  /**
   * Round number
   */
  get mod() {
    if (!this.isDecimal) return Math.round(this.actualValue);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return +(`${Math.round(`${this.actualValue}e+3`)}e-3`);
  }

  /**
   * Left maximum two numbers after comma
   */
  get filtered(): any {
    return Number.isInteger(this.mod) ? this.mod : this.mod.toFixed(2);
  }

  /**
   * Converting number to locale format
   */
  get localisation() {
    const filteredByMinMax = () => {
      if (this.min > +this.filtered) return this.min;
      if (this.max < +this.filtered) return this.max;
      return this.filtered;
    };
    if (this.disableMinMaxFilter === false) {
      if (filteredByMinMax() !== 'NaN') {
        return Intl.NumberFormat('de-GE').format(filteredByMinMax());
      } else {
        return 0;
      }
    } else {
      return this.filtered;
    }
  }
  get isNotMapped(): boolean {
    return this.mappingsClean.actualValue === '';
  }
}
